/**
 * Home service (F46) — `GET /api/home`, `POST /api/home/snooze` and
 * `POST /api/home/checkup-link`.
 *
 * The summary is display-ready and server-ranked; nothing here reshapes it.
 */
import type { HomeCheckUpLinkResult, HomeSnoozeRequest, HomeSummary } from '@tonnie/types';

import { TonnieClient } from '../client/base';

export class HomeService {
  constructor(private client: TonnieClient) {}

  /** The Home summary for one journey (the caller's primary when omitted). Pure read. */
  async getSummary(journeyId?: string): Promise<HomeSummary> {
    const qs = journeyId ? `?journeyId=${encodeURIComponent(journeyId)}` : '';
    return this.client.get<HomeSummary>(`/api/home${qs}`);
  }

  /** "Later" on one item (204). An invitation's is the invitation's own defer. */
  async snooze(request: HomeSnoozeRequest): Promise<void> {
    await this.client.post<void>('/api/home/snooze', request);
  }

  /** Email the citizen the CheckUp link, for a computer (Citizen Mobile · D-M3). */
  async emailCheckUpLink(): Promise<HomeCheckUpLinkResult> {
    return this.client.post<HomeCheckUpLinkResult>('/api/home/checkup-link', {});
  }
}

export function createHomeService(client: TonnieClient): HomeService {
  return new HomeService(client);
}
